import { DeleteOutlined } from "@ant-design/icons";
import {
  Breadcrumb,
  Col,
  message,
  Popconfirm,
  Row,
  Tooltip,
  Typography,
} from "antd";
import { useContext, useEffect, useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import SecondaryButton from "../../../components/Buttons/SecondaryButton";
import CardInfo from "../../../components/Cards/CardInfo";
import FullPageLoader from "../../../components/Loaders/FullPageLoader";
import AddProtocolSubscription from "../../../components/Modals/AddProtocolSubscription";
import SubscriptionCoordinators from "../../../components/Tables/SubscriptionCoordinators";
import SubscriptionGroups from "../../../components/Tables/SubscriptionGroups";
import SubscriptionProfessionals from "../../../components/Tables/SubscriptionProfessionals";
import SubscriptionUsers from "../../../components/Tables/SubscriptionUsers";
import TransferCategoriesStrapiCapsule from "../../../components/Transfers/TransferCategoriesStrapiCapsule";
import { translate } from "../../../locale";
import { AdminContext } from "../../../providers/AdminContext";
import CompanyServices from "../../../services/CompanyServices";
import DashServices from "../../../services/DashServices";
import ProtocolServices from "../../../services/ProtocolServices";
import FormSubscription from "./FormSubscription";

const { Title, Text } = Typography;

const EditSubscription = () => {
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [reloadTable, setReloadTable] = useState(0);
  const [values, setValues] = useState({});
  const [modules, setModules] = useState([]);
  const [protocols, setProtocols] = useState([]);
  const { id } = useParams();
  const [modalAddProtocol, setModalAddProtocol] = useState(false);
  const [openPopupConfirm, setOpenPopupConfirm] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [selectedProtocol, setSelectedProtocol] = useState(null);
  const [deleteSelectedProtocol, setDeleteSelectedProtocol] = useState(null);
  const [enterpriseId, setEnterpriseId] = useState(
    location.state !== null ? location.state.enterprise : null
  );
  const [strapiCategories, setStrapiCategories] = useState([]);
  const navigate = useNavigate();
  const { user } = useContext(AdminContext);
  const [isSuper, setIsSuper] = useState(false);

  useEffect(() => {
    if (id !== null && id !== undefined) {
      getSubscription();
      loadProtocols();
    }
    if (user !== null && user !== undefined) {
      setIsSuper(user.user.rol === "eira-super-admin");
    }
    window.scrollTo(0, 0);
  }, [id, user]);

  const getSubscription = async () => {
    setLoading(true);
    try {
      const res = await DashServices.getSubscriptions(id);
      if (res.status >= 200 && res.status < 300) {
        setValues(res.data.subscription);
        setEnterpriseId(res.data.subscription.enterprise.id);
        setModules(res.data.subscription.modules);
        setStrapiCategories(res.data.subscription.categories);
      }
    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  };

  const loadProtocols = async () => {
    setLoading(true);
    try {
      const res = await ProtocolServices.getProtocolsSubscription(id);
      if (res.status >= 200 && res.status < 300) {
        setProtocols(res.data.protocols);
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const addModules = () => {
    navigate("/admin/subscriptions/modules/" + id, {
      state: {
        user_modules: modules,
        enterprise: enterpriseId,
        values: values,
      },
    });
  };

  const handleDeleteProtocol = (protocol) => {
    setSelectedProtocol(null);
    setDeleteSelectedProtocol(protocol);
    setOpenPopupConfirm(true);
  };

  const handleConfirmDeleteProtocol = async (e) => {
    e.stopPropagation();
    setDeleteSelectedProtocol(null);
    setSelectedProtocol(null);
    setOpenPopupConfirm(false);
    try {
      setConfirmLoading(true);
      if (deleteSelectedProtocol !== null) {
        const res = await ProtocolServices.updateProtocol({
          subscriptions_delete: [values.id],
          protocol_id: deleteSelectedProtocol.id,
        });
        if (res.status >= 200 && res.status < 300) {
          message.success(
            translate("El {0} se eliminó exitosamente.", translate("protocolo"))
          );
          loadProtocols();
        } else if (res.data.error === true) {
          message.error(res.data.message);
        } else {
          message.error(
            translate("No se pudo desconectar el {0}.", translate("protocolo"))
          );
        }
      } else {
        throw translate("No se seleccionó un {0}.", translate("protocolo"));
      }
      setConfirmLoading(false);
    } catch (error) {
      console.log("error", error);
      message.error(error);
      setConfirmLoading(false);
    }
  };

  const handleCancel = (e) => {
    e.stopPropagation();
    setDeleteSelectedProtocol(null);
    setSelectedProtocol(null);
    setOpenPopupConfirm(false);
  };
  const connectProtocol = () => {
    setModalAddProtocol(true);
  };

  const handleCancelAddProtocol = () => {
    setModalAddProtocol(false);
  };

  const handleCompleteAddProtocol = () => {
    setModalAddProtocol(false);
    loadProtocols();
  };

  const handleInitialProtocol = (protocol_id) => {
    setDeleteSelectedProtocol(null);
    setSelectedProtocol(protocol_id);
    setOpenPopupConfirm(true);
  };

  const handleClickStatus = async (protocol_id) => {
    setDeleteSelectedProtocol(null);
    setSelectedProtocol(null);
    setOpenPopupConfirm(false);
    try {
      setLoading(true);
      const res = await CompanyServices.setInitialProtocolSubscription({
        enterprise_id: values.enterprise.id,
        modules: values.modules.map((i) => i.module),
        subscription_id: values.id,
        initial_protocol: selectedProtocol,
      });
      if (res.status >= 200 && res.status < 300) {
        message.success(
          translate(
            "La {0} se actualizó exitosamente.",
            translate("suscripción")
          )
        );
        getSubscription();
      }
      setLoading(false);
    } catch (error) {
      console.log("error", error);
      message.error(error);
      setLoading(false);
    }
  };
  const onChangeRole = (oldRole, newRole) => {
    setReloadTable((v) => v + 1);
  };

  const getSubmodules = (item) => {
    if (item.name === "Alimentacion")
      return item.submodules?.map((it) => {
        return (
          it.selected && (
            <Row className="ml-4" key={it.label}>
              <Col className="flex flex-row">
                <div className="h-2 w-2 bg-custom_darkgray rounded-full mt-2" />
                <div className="ml-4">{it.label}</div>
              </Col>
            </Row>
          )
        );
      });

    if (item.name === "SaturacionO2")
      return (
        <>
          {item.items?.map(
            (it) =>
              it !== "Frecuencia respiratoria" && (
                <Row className="ml-4" key={it}>
                  <Col className="flex flex-row">
                    <div className="h-2 w-2 bg-custom_darkgray rounded-full mt-2" />
                    <div className="ml-4">{it}</div>
                  </Col>
                </Row>
              )
          )}
          {item.submodules?.map(
            (it) =>
              it.selected && (
                <Row className="ml-4" key={it.label}>
                  <Col className="flex flex-row">
                    <div className="h-2 w-2 bg-custom_darkgray rounded-full mt-2" />
                    <div className="ml-4">{it.label}</div>
                  </Col>
                </Row>
              )
          )}
        </>
      );

    return item.items?.map((it) => (
      <Row className="ml-4" key={it}>
        <Col className="flex flex-row">
          <div className="h-2 w-2 bg-custom_darkgray rounded-full mt-2" />
          <div className="ml-4">{it}</div>
        </Col>
      </Row>
    ));
  };

  return (
    <div className="flex flex-col min-h-full w-screen max-w-7xl pb-16 m-10">
      <Row>
        <Col className="gutter-row" span="24">
          <Breadcrumb>
            <Breadcrumb.Item>
              <Link to="/admin">{translate("Inicio")}</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link to="/admin/subscriptions">
                {translate("Suscripciones")}
              </Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>{translate("Editar suscripción")}</Breadcrumb.Item>
          </Breadcrumb>
        </Col>
        <Col span="24" className="my-4">
          <Title level={2} className="text-center">
            {translate("Configuración de suscripción")}
          </Title>
          <div className="flex flex-col justify-center items-center w-full mb-8 bg-gray-200">
            <Title level={4} className="my-4 uppercase">
              {translate("Información general")}
            </Title>
          </div>
          <div className="px-6">
            <FormSubscription
              type={"edit"}
              enterprise_id={enterpriseId}
              data={values}
              setdata={setValues}
              modules={modules}
            />
          </div>

          {values.has_groups && (
            <>
              <div className="flex flex-col justify-center items-center w-full my-8 bg-gray-200">
                <Title level={4} className="my-4 uppercase">
                  {translate("Grupos")}
                </Title>
              </div>
              <SubscriptionGroups subscription={values} reload={reloadTable} />
            </>
          )}

          <div className="flex flex-col justify-center items-center w-full my-8 bg-gray-200">
            <Title level={4} className="my-4 uppercase">
              {translate("Protocolos")}
            </Title>
          </div>

          <Row gutter={[16, 24]}>
            <Col span="24" className="mb-6">
              <SecondaryButton
                onClick={connectProtocol}
                className="mb-4 hover:border-custom_primary hover:text-custom_primary"
              >
                {translate("Conectar {0}", translate("protocolo"))}
              </SecondaryButton>
              <AddProtocolSubscription
                visible={modalAddProtocol}
                subscription={values}
                onCancel={handleCancelAddProtocol}
                onComplete={handleCompleteAddProtocol}
              />
            </Col>
            {protocols.length > 0 &&
              protocols.map((item) => (
                <Col span="6" key={item.id}>
                  <CardInfo
                    topLeftButton={
                      <Popconfirm
                        title={
                          <>
                            {translate(
                              "¿Está seguro de que quiere desvincular este protocolo de la suscripción?"
                            )}
                            <br />
                            {translate("Esta acción no se puede deshacer")}
                          </>
                        }
                        open={
                          item.id === deleteSelectedProtocol?.id &&
                          openPopupConfirm
                        }
                        onConfirm={handleConfirmDeleteProtocol}
                        okButtonProps={{ loading: confirmLoading }}
                        onCancel={handleCancel}
                      >
                        <Link
                          className="border-0 shadow-none"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleDeleteProtocol(item);
                          }}
                        >
                          <DeleteOutlined />
                        </Link>
                      </Popconfirm>
                    }
                    title={item.name}
                    onClick={
                      isSuper
                        ? () => navigate("/admin/protocols/" + item.id)
                        : false
                    }
                    showStatus={false}
                    topRightButton={
                      <Popconfirm
                        title={translate(
                          "¿Está seguro de seleccionar este protocolo como inicial de la suscripción?"
                        )}
                        open={item.id === selectedProtocol && openPopupConfirm}
                        onConfirm={(e) => {
                          e.stopPropagation();
                          handleClickStatus(item.id);
                        }}
                        okButtonProps={{ loading: confirmLoading }}
                        onCancel={handleCancel}
                      >
                        <Tooltip
                          title={translate("Marcar como protocolo inicial")}
                          className="rounded"
                        >
                          <Link
                            className="border-0 shadow-none cursor-pointer w-auto pt-2"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleInitialProtocol(item.id);
                            }}
                          >
                            <div
                              className={`w-4 h-4 mr-0 rounded-full hover:bg-custom_green hover:opacity-40 ${
                                values.initial_protocol === item.id
                                  ? `bg-custom_green`
                                  : "bg-custom_lightgray"
                              }`}
                            />
                          </Link>
                        </Tooltip>
                      </Popconfirm>
                    }
                  />
                </Col>
              ))}
          </Row>
          <div className="flex flex-col justify-center items-center w-full my-8 bg-gray-200">
            <Title level={4} className="my-4 uppercase">
              {translate("Módulos")}
            </Title>
          </div>
          <Row gutter={[16, 32]} className="mb-8">
            <Col span="24" className="mb-8">
              <SecondaryButton
                onClick={addModules}
                className="hover:border-custom_primary hover:text-custom_primary"
              >
                {translate("Agregar módulos")}
              </SecondaryButton>
            </Col>
            {modules.length > 0 &&
              modules.map((item) => (
                <Col key={item.module} span={6}>
                  <Text
                    level={4}
                    className="font-medium underline decoration-1"
                  >
                    {item.label}
                  </Text>
                  {getSubmodules(item)}
                </Col>
              ))}
          </Row>
          <div className="flex flex-col justify-center items-center w-full my-8 bg-gray-200">
            <Title level={4} className="my-4 uppercase">
              {translate("Categorías de Cápsulas strapi")}
            </Title>
          </div>
          <Row gutter={[16, 32]} className="mb-8">
            <Col span="24" className="mb-8">
              <TransferCategoriesStrapiCapsule
                subscriptionId={values.id}
                enterpriseId={enterpriseId}
                selectedCategories={strapiCategories}
              />
            </Col>
          </Row>
          <div className="flex flex-col justify-center items-center w-full my-8 bg-gray-200">
            <Title level={4} className="my-4 uppercase">
              {translate("Coordinadores")}
            </Title>
          </div>
          <SubscriptionCoordinators
            subscription={values}
            reload={reloadTable}
            onChange={onChangeRole}
          />

          <div className="flex flex-col justify-center items-center w-full my-8 bg-gray-200">
            <Title level={4} className="my-4 uppercase">
              {translate("Profesionales")}
            </Title>
          </div>
          <SubscriptionProfessionals
            subscription={values}
            reload={reloadTable}
            onChange={onChangeRole}
          />

          <div className="flex flex-col justify-center items-center w-full my-8 bg-gray-200">
            <Title level={4} className="my-4 uppercase">
              {translate("Usuarios")}
            </Title>
          </div>
          <SubscriptionUsers subscription={values} />
        </Col>
      </Row>

      {loading && <FullPageLoader />}
    </div>
  );
};

export default EditSubscription;
